import React from 'react';
import PropTypes from 'prop-types';
import { routes, url } from 'oo-routes';

import Link from 'sp-components/components/Link';

import NavBar from '../../../components/NavBar2';

import './styles';

export default class HomePageHero extends React.Component {
  static propTypes = {
  }

  state = {}

  render() {
    return (
      <div className="HomePageHero">
        <div className="image-background">
          <div className="center-content center-aligned">
            <h1 className="m-b-1">
              FAST, AFFORDABLE<br />
              PRINT-ON-DEMAND FULFILLMENT
            </h1>
            <div className="p-b-0_5" />
            <div className="center-aligned m-t-0 m-b-2 fs-2 sub-header">
               Scalable Press lets you order 1000s of print-on-demand products from different suppliers through a single-invoice ordering platform
            </div>
            <div className="p-b-0_5" />
            <a href={url('website', routes.website.auth.register)} className="ui primary button levitated">
              REQUEST AN ACCOUNT
            </a>
          </div>
          <div className="facilities center-aligned secondary-text-color computer-only">
            <div className="content">
              <h5 className="divider m-b-0_5">
                <i>10+ SUPPLIERS DISTRIBUTED GLOBALLY</i>
              </h5>
              <div className="cities fw-700">
                <div className="city">
                  Los Angeles, CA
                </div>
                <div className="city">
                  Dallas, TX
                </div>
                <div className="city">
                  Toronto, ON
                </div>
                <div className="city">
                  Exeter, UK
                </div>
                <div className="city">
                  Prague, CZ
                </div>
                <div className="city">
                  Zhejiang, CN
                </div>
                <div className="city">
                  Melbourne, AU
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="fulfillment center-aligned mobile-only tablet-only p-v-1">
          <h5 className="m-b-0_5">WE ARE NATIONAL AND WE SHIP FAST</h5>
          <p>5 fulfillment facilities across US</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/NavBar2/HomePageHero/index.jsx